import { CacheLocation } from '@auth0/auth0-spa-js';
import { environment_org } from './environment_organization';

const SERVICENOW_HOST = 'https://anityademo1.service-now.com/';

export const environment = {
  production: true,
  apiEndPoint: 'https://g23-newpos-dev-master-back-rivcwsgbgq-an.a.run.app/',
  tableauHost: 'https://dev-asahig-bidashboard.biz', //'https://hd-keieidashboard-1766.biz',
  organization: environment_org.organization,

  servicenow: {
    host: SERVICENOW_HOST,
    masterMaintenanceURL: SERVICENOW_HOST + 'sp?id=sc_cat_item&sys_id=33bcc07c1b67b8506bc88596dc4bcbc9',
    myRequestsURL: SERVICENOW_HOST + 'sp?id=my_requests'
  },

  auth0: {
    domain: 'asahig-dev.jp.auth0.com',
    clientId: 'yhhkNE0SIFYZlwpGyPUTYkWpqjeYxq9N',
    useRefreshTokens: true,
    skipRedirectCallback: true,
    redirectUri: environment_org.auht0_redirectUri.dev,
    cacheLocation: 'localstorage' as CacheLocation,
  },

  auth0Audience: 'asahig-api'
};
